import Request from '../data/request';
import DateTimeUtils from "../utils/datetime-utils";

export default class ApiMeeting {


    static myMeetings(startDate:Moment, endDate:Moment, userId?:ID) {
        return new Request(this,'GET','my-work/my-meetings', {
            startDate   : gd.utils.momentToDate(startDate),
            endDate     : gd.utils.momentToDate(endDate),
            userId      : userId,
        });
    }


    newMeeting(name:string, startMoment:Moment, endMoment:Moment, users:any[], projectId?:ID) {
        /*
        * "startMoment": "2020-02-05T11:00:00.0Z",
        * "endMoment": "2020-02-05T11:30:00.0",
        * "name": "Meeting A",
        * "users": ["Ym6i3T", "huiw87"],
        */

        return new Request(this, 'POST', 'new/meeting', {
            name:           name,
            startMoment:    DateTimeUtils.momentToUTCISODatetime(startMoment),
            endMoment:      DateTimeUtils.momentToUTCISODatetime(endMoment),
            users:          users,
            projectId:      projectId
        });
    }

    meetingView(meetingId:ID) {
        return new Request(this, 'GET', 'meeting/{0}'.f(meetingId));
    }

    meetingDelete(meetingId:ID) {
        return new Request(this, 'DELETE', 'meeting/{0}'.f(meetingId));
    }

    meetingUpdate(meetingId:ID, data:any) {
        return new Request(this, 'PUT', 'meeting/{0}'.f(meetingId), data);
    }

    // create new note
    meetingAddNote(meetingId:ID, title:string, access:number, contentText:string, contentRtf:any) {
        return new Request(this, 'POST', 'meeting/{0}/notes'.f(meetingId), {
            title,
            access,
            contentText,
            contentRtf
        });
    }

    meetingUpdateNote(meetingId:ID, noteId:ID, data:any) {
        /* data
        * "title": "new meeting name",
        * "access": 2,
        * "contentRtf": {"some": "params"},
        * "contentText": "text in here",
        */

        return new Request(this, 'PUT', 'meeting/{0}/notes/{1}'.f(meetingId, noteId), data);
    }

    meetingGetNote(meetingId:ID, noteId:ID) {
        return new Request(this, 'GET', 'meeting/{0}/notes/{1}'.f(meetingId, noteId));
    }

    meetingDeleteNote(meetingId:ID, noteId:ID) {
        return new Request(this, 'DELETE', 'meeting/{0}/notes/{1}'.f(meetingId, noteId));
    }
}
